import { CopyAll } from "@mui/icons-material";
import { IconButton, Paper, TextField, Tooltip } from "@mui/material";
import { PageWithNav } from "features/Navbar/PageWithNav";
import { useEffect, useState } from "react";
import AuthService from "services/AuthService";
import { CountdownTimer } from "shared-components/CountdownTimer";
import styled from "styled-components";
import { setInterval } from "timers";

const StyledPageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const GenerateOTP = () => {
  const [verificationCode, setVerificationCode] = useState("");
  const [timeRemaining, setTimeRemaining] = useState<number>(0);

  useEffect(() => {
    if (timeRemaining === 0) {
      generateOTP();
    }
  }, [timeRemaining]);

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeRemaining((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const generateOTP = async () => {
    await AuthService.getOTP().then((e) => {
      setTimeRemaining(e.data.timeRemaining);
      setVerificationCode(e.data.verificationCode);
      setCopyText("Copy Code");
    });
  };

  const [copyText, setCopyText] = useState("Copy Code");
  const handleCopy = () => {
    if (verificationCode) {
      navigator.clipboard.writeText(verificationCode).then(() => {
        setCopyText("Copied Code");
      });
    }
  };

  return (
    <PageWithNav>
      <StyledPageContainer>
        <Paper
          style={{ display: "flex", flexDirection: "column", padding: "20px" }}
        >
          <TextField
            value={verificationCode}
            label="Verification Code"
            disabled
            InputProps={{
              endAdornment: (
                <>
                  <CountdownTimer timeRemaining={timeRemaining} maxTime={30} />
                  <div style={{ margin: "5px" }}>
                    <Tooltip title={copyText}>
                      <IconButton onClick={handleCopy} edge="end">
                        <CopyAll />
                      </IconButton>
                    </Tooltip>
                  </div>
                </>
              ),
            }}
          />
        </Paper>
      </StyledPageContainer>
    </PageWithNav>
  );
};
